export default "__VITE_ASSET__B3kKWDeC__"